<template>
  <div
    :class=" {
      'form-check': plain,
      'form-check-inline': plain && inline,
      'custom-control': isCustom,
      'custom-radio': isCustom,
      'custom-control-inline': isCustom && inline
    }"
  >
    <slot />
  </div>
</template>

<script>

export default {
  name: 'BFormRadioWrapper',
  props: {
    plain: Boolean,
    inline: Boolean,
    isCustom: Boolean
  }
}
</script>
